const Items = [
  {
    id: 1,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682699543/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-1_rmh7lp.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682699543/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-1_rmh7lp.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682699548/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-2_p3chy5.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682699706/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-3_uhtwa6.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682699802/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-4_p404nm.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682700118/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-5_mksj57.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682700238/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-6_jfndeo.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682700374/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-7_uhh453.png",
    ],
    features: [
      "Home",
      "About",
      "Package",
      "Contact",
      "Blog",
      "A user can order through the Admin for Website services, Mobile Applications, Branding & Creative Content, as well as Internet Marketing & Advertising.",
      "Responsive Design",
      "404 Page and many more.",
    ],
    technologies: [
      "React",
      "TailwindCSS",
      "React Leaflet",
      "React Hooks",
      "React icons",
      "Email JS",
      "Framer Motion",
    ],
    title: "Msn Production",
    description:
      "PT. MULIA SEJATI NUSANTARA Established on June 24, 2019, a limited liability company engaged in supplier & contractor services. Then on January 22 2022 PT. MULIA SEJATI NUSANTARA Opening a new business branch in the Technology Sector which includes Website Creation, Mobile Applications, Branding, Creative Content, Digital Marketing & Advertising. This branch is called Mulia Sejati Nusantara Production or in short MSN PRODUCTION.",
    category: "business",
    liveLink: "https://msnproduction.com/",
    codeLink: "https://github.com/berthutapea/msnproduction.com",
  },
  {
    id: 2,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682701479/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-4_kmaye9.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701456/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-1_jppjdj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701463/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-2_ptr4lg.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701467/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-3_gjle1m.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701479/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-4_kmaye9.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701489/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-5_nuhniv.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701492/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-6_rkvmhd.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701496/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-7_xjm4pm.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701499/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-8_dj0qoq.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701502/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-9_d1h5a0.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701505/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-10_kbbkd4.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682701506/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-11_mmspfs.png",
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Story searching and pagination",
      "CRUD operations (Story create, read, update and delete)",
      "Upload user ımages and story ımages to the server",
      "Liking stories and adding stories to the Reading list",
      "Commenting on the story",
      "Skeleton loading effect",
      "Responsive Design",
      "404 Page and many more.",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",
      "Axios",
      "CSS",
      "UUID",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Express Asynsc Handler",
      "Json Web Token",
      "Bcryptjs",
      "Nodemailer",
      "Dontenv",
      "Multer",
      "Slugify",
      "Cors",
    ],
    title: "Mern Blog",
    description:
      "Fullstack open source blogging application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "personal",
    liveLink: "https://berthutapea.vercel.app/mern-blog",
    codeLink: "https://github.com/berthutapea/mern-blog-v2",
  },
  {
    id: 3,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1684312778/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-1_lcun2a.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312778/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-1_lcun2a.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312777/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-2_ar1fex.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312780/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-3_qpebgb.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312777/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-4_yadwtg.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312780/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-5_xvx0vj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312773/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-6_aaq4yf.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312772/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-7_twij3j.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312773/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-8_njclct.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312774/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-9_zg1jfe.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312772/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-10_yag7bj.png",
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Add Favorites",
      "Delete Favorites",
      "Leave a Reviews",
      "Delete Reviews",
      "Password Update",
      "Search Live",
      "Watch the trailer on Youtube",
      "404 Page and many more",
      "Skeleton loading effect",
      "DarkMode",
      "DarkMode",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Material UI",
      "CK Editor",
      "Formik",
      "React Redux",
      "React Toastify",
      "Swiper",
      "NodeJS",
      "ExpressJS",
      "Mongoose",
      "Json Web Token",
      "Cookie Parser",
      "Cors",
      "Dontenv",
      "Express Validator",
      "Nodemon",
      "MongoDB",
      "TMDB API",
    ],
    title: "BertFlix",
    description:
      "Fullstack open source movie application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "personal",
    liveLink: "https://bertflix.vercel.app/",
    codeLink: "https://github.com/berthutapea/mern-movie",
  },
  {
    id: 4,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-2_vsab0u.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-1_gywmlj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-2_vsab0u.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-3_ktppfh.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-4_g9pcqp.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-5_cugdqq.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-6_d550ha.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-7_u2td2u.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-8_tt0tqg.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-9_thcxyv.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-10_wwmqty.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-11_issyrd.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-12_visvli.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-13_dqy6wg.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-14_kvaem7.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-15_pzdxsu.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-16_ven89o.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-17_wjwedp.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-18_zpsewd.png",
    ],
    features: [
      "Login Admin",
      "Add employee",
      "Edit employee",
      "Remove employee",
      "Add position",
      "Edit position",
      "Remove position",
      "Display data, input attendance, edit attendance and delete employee absences",
      "Employee Salary Deduction Setting",
      "Display data, input salary data, edit salary data and delete employee salary data",
      "Print payroll reports, absences, and payslips",
      "Change admin and employee passwords",
      "Login Employees/Staff",
      "Print employees/staff salary reports from personal accounts",
      "404 Page and many more",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",
      "React Vite",
      "Redux",
      "Redux Toolkit",
      "Tailwind CSS",
      "Apexcharts",
      "Localforage",
      "Match Sorter",
      "Axios",
      "Node JS",
      "Express JS",
      "MySQL",
      "Cors",
      "JWT",
      "Bycrypt",
      "Cookie Parser",
      "Dotenv",
      "MySQL 12",
      "Nodemon",
      "Sequelize",
    ],
    title: "Employee Salary Management",
    description:
      "Warehouse website with employee/employee management, add employee and job title options. Employee attendance data setting salary deductions and salary data. Print salary reports, attendance and salary data and many other features.",
    category: "business",
    liveLink: "https://berthutapea.vercel.app/employee-salary-management",
    codeLink: "https://github.com/berthutapea/mern-employee-salary-management",
  },
  {
    id: 5,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-1_yhedpu.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-1_yhedpu.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-2_uktrxk.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-3_s1js9i.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-4_sb9ga6.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683869748/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-5_wrxlr7.png",
    ],
    features: [
      "Add Student",
      "Edit Student",
      "Remove Student",
      "No Student Page",
      "Responsive Design",
      "404 Page and many more",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Bootstrap",
      "React Icons",
      "Sweet Alert2",
      "Node JS",
      "Express JS",
      "Cors",
      "Mongoose",
      "Dotenv",
      "Nodemon",
      "MongoDB",
    ],
    title: "Student Management System",
    description:
      "Fullstack open source student management system application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "business",
    liveLink: "https://sttiss.vercel.app/",
    codeLink: "https://github.com/berthutapea/mern-student-management-system",
  },
  {
    id: 6,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682964283/Blog%20Portfolio%20Gilbert/Project/mario-jump-game/img-2_iwduig.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682964283/Blog%20Portfolio%20Gilbert/Project/mario-jump-game/img-1_gpiiro.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682964283/Blog%20Portfolio%20Gilbert/Project/mario-jump-game/img-2_iwduig.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682964283/Blog%20Portfolio%20Gilbert/Project/mario-jump-game/img-3_sk2hyn.png",
    ],
    features: [
      "Mobile Responsive",
      "Beautiful Animations",
      "Rapid Controls",
      "High Score",
      "Mario Background Music",
      "Jump & Game Over Sound Effect",
    ],
    technologies: [
      "React",
      "CSS",
      "React Hooks",
      "React Router",
      "React Redux",
    ],
    title: "Mario Jump",
    description:
      "Mario Jump is an endless running game inspired by the famous Google Chrome's T-Rex Dinosaur Game 🦖. The game is built entirely with ReactJS ⚛ and Redux Toolkit 🔧.",
    category: "game",
    liveLink: "https://mariojumpp.vercel.app/",
    codeLink: "https://github.com/berthutapea/mario-jump-game",
  },
  {
    id: 7,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682944695/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-3_t6uxoj.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-1_gqero4.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-2_ukjdh2.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944695/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-3_t6uxoj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-4_btevir.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-5_oakjx2.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944092/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-6_pqefy9.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-7_wfrvb7.png",
    ],
    features: [
      "User registration and login",
      "Select the type of question and the difficulty level of the question",
      "Juis time is running and after the time is up it stops automatically",
      "The final results of the answers answered will be shown",
      "Incorrect and correct answer results will be displayed",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Vite",
      "Tailwind CSS",
      "Firebase Authentication",
      "Framer Motion",
      "React Firebase Hooks",
      "React Icons",
    ],
    title: "Bert Quiz",
    description:
      "Fullstack open source quiz application",
    category: "personal",
    liveLink: "https://bertquiz.vercel.app/",
    codeLink: "https://github.com/berthutapea/react-quiz",
  },
  {
    id: 8,
    mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-1_q5d6pn.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-1_q5d6pn.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683033411/Blog%20Portfolio%20Gilbert/Project/shopify/img-2_nko9ic.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683033413/Blog%20Portfolio%20Gilbert/Project/shopify/img-3_rnhbr1.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-4_ks8lck.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683033409/Blog%20Portfolio%20Gilbert/Project/shopify/img-5_eotroj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-6_fgpzef.png",
    ],
    features: [
      "Mobile Responsive",
      "Beautiful Animations",
      "Product",
      "Pricing",
      "Testimonial",
      "Contact",
    ],
    technologies: [
      "React",
      "React Vite",
      "Tailwind CSS",
      "Framer Motion",
      "React Icons",
      "React Hooks",
    ],
    title: "Shopify",
    description:
      "Open source landing page shopify application",
    category: "personal",
    liveLink: "https://shopifyy.vercel.app/",
    codeLink: "https://github.com/berthutapea/react-shopify-landing",
  },
];

export default Items;
